import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/common/base/base.component';
import { DocumentCategory, DocumentType } from 'src/app/services/documents/documents';

@Component({
  selector: 'cl-editor-checklist-type-selector',
  templateUrl: './cl-editor-checklist-type-selector.component.html',
  styleUrls: ['./cl-editor-checklist-type-selector.component.scss']
})
export class ClEditorChecklistTypeSelectorComponent extends BaseComponent implements OnInit, OnDestroy {

  @Input() configuration?: string;
  @Input() disabled?: boolean;
  @Output() configurationChanged = new EventEmitter<string>();

  documentType?: DocumentType | null;
  documentTypes?: DocumentType[];
  documentTypesFiltered?: DocumentType[];
  documentTypesSubs!: Subscription;

  ctrlDocumentType = new FormControl();
  checklistTypeID?: number;

  ngOnInit(): void {
    const configuration = this.utils.JSONparse(this.configuration);
    if (configuration)
      this.checklistTypeID = configuration.ChecklistTypeID;
    this.loadDocumentTypes();
    this.disabled ? this.ctrlDocumentType.disable() : this.ctrlDocumentType.enable();
  }

  override ngOnDestroy(): void {
    this.documentTypesSubs?.unsubscribe();
  }

  override displayObject(e: any) {
    return e ? e.description : null;
  }

  loadDocumentTypes() {
    this.documentTypesSubs = this.store.select(state => state.DocumentType.data).subscribe((data: DocumentType[]) => {
      if (data?.length) {
        this.documentTypes = data.filter(d => d.category == DocumentCategory.Checklist);
        this.filterDocumentTypes();
        this.documentType = this.documentTypesFiltered?.find(d => d.id == this.checklistTypeID);
        this.ctrlDocumentType.setValue(this.documentType);
      }
    });
  }

  filterDocumentTypes(e?: any) {
    const filterValue = e?.target.value?.toLowerCase();
    this.documentTypesFiltered = this.documentTypes?.filter(
      (o) => !filterValue || o.name?.toLowerCase().includes(filterValue) || o.description?.toLowerCase().includes(filterValue)
    ).sort((a, b) => this.utils.sort(a.description, b.description));
  }

  onDocumentTypeSelected(e: MatAutocompleteSelectedEvent) {
    this.documentType = e.option?.value as DocumentType;
    this.checklistTypeID = this.documentType.id;
    let configuration = this.utils.JSONparse(this.configuration);
    if (configuration)
      configuration.ChecklistTypeID = this.checklistTypeID;
    else configuration = { ChecklistTypeID: this.checklistTypeID };
    this.configurationChanged.emit(this.utils.JSONstringify(configuration));
  }

}
